<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 
              | Reasignaciones
              | &nbsp
              router-link.a.button.is-dark.is-rounded.is-size-6.is-medium(to="/Inventario/Busqueda")
                i.fas.fa-times
        .columns
          .column.is-4
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por Anterior | Actual | Ubicación',
                  v-model="query_articulos",
                )
          .column.is-offset-4.is-4
            router-link.a.button.is-dark.is-rounded.is-size-6.is-pulled-right(to="/Inventario/Reasignacion/Nueva")
              | Nueva Reasignación&nbsp
              i.fas.fa-sync
        .columns
          .column
            TablaReasignaciones
        .columns.column-blanco
</template>

<script>
  import TablaReasignaciones from './TablaReasignaciones.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import Loader from '../shared/Loader.vue'
  export default {
    name: 'Reasignaciones',
    components: { TablaReasignaciones, NavBarInventario, Loader },
    data() {
      return {
        isLoading: true,
        query_articulos: ''
      }
    },
    methods: {
      inciarComponente() {
        setTimeout(() => {
          this.isLoading = false
        }, 350)
      }
    },
    created () {
      this.inciarComponente()
    },
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/Reasignaciones.vue